// JOBE-0044.6: shared row template used by all three rail blocks
// (SavedViewsBlock, TypeRailBlock, CollectionsRailBlock). Glyph (14 px)
// / label / optional source pill / trailing count.
//
// Per the spec's R3 shared-row-template note. The pill renders as a
// small badge whose class encodes the source (`core` / `user` /
// `collection`); JOBE-0044.7 owns the visual treatment.

export function RailRow({
  glyph = '·',
  label,
  pill = null,
  count = null,
  selected = false,
  onClick,
  title,
  children,
  // chevron: optional expand/collapse affordance for tree-mode type rows.
  chevron = null,
  // extraClassName: opt-in extension hook for variant styling (e.g.,
  // `library-rail-row-skeleton` on the loading-state row).
  extraClassName = '',
}) {
  const className =
    `library-rail-row${selected ? ' library-rail-row-selected' : ''}` +
    (extraClassName ? ` ${extraClassName}` : '');

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      title={title}
      aria-pressed={selected || undefined}
    >
      {chevron != null && <span className="library-rail-row-chevron">{chevron}</span>}
      <span className="library-rail-row-glyph" aria-hidden="true">{glyph}</span>
      <span className="library-rail-row-label">{label}</span>
      {pill && (
        <span
          className={`library-rail-row-pill library-rail-row-pill-${pill.kind}`}
        >
          {pill.label}
        </span>
      )}
      {count != null && (
        <span className="library-rail-row-count">{count}</span>
      )}
      {children}
    </button>
  );
}
